const reasons = [
  {
    icon: 'ri-search-eye-line',
    title: 'Диагностика до обучения',
    desc: 'Сначала определяем реальные задачи компании и уровень участников, а не начинаем с готовой программы.',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Реальные рабочие ситуации',
    desc: 'Разбираем задачи, с которыми сотрудники сталкиваются в ежедневной работе, а не только абстрактные примеры.',
  },
  {
    icon: 'ri-tools-line',
    title: 'Практика',
    desc: 'Навыки отрабатываются через упражнения, ролевые ситуации и рабочие кейсы, а не только через теорию.',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Адаптация',
    desc: 'Программа подстраивается под компанию, отрасль, задачи и уровень участников.',
  },
  {
    icon: 'ri-rocket-line',
    title: 'Внедрение',
    desc: 'Новые инструменты переносятся в ежедневную работу, а не остаются в конспекте тренинга.',
  },
  {
    icon: 'ri-compass-3-line',
    title: 'Сопровождение',
    desc: 'При необходимости работа с командой продолжается после обучения.',
  },
  {
    icon: 'ri-archive-line',
    title: 'Систематизация',
    desc: 'При необходимости создаются алгоритмы, чек-листы, методические материалы и другие инструменты.',
  },
];

export default function WhyProgramsWork() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Почему наши программы работают
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Обучение не заканчивается тренингом. Вот почему сотрудники действительно меняют рабочее поведение, а не просто получают новые знания.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {reasons.map((r, i) => (
            <div key={i} className="bg-gray-50 rounded-xl border border-gray-100 p-5 md:p-6 hover:border-teal-200 transition-colors group">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-200 transition-colors">
                <i className={`${r.icon} text-xl text-teal-700`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{r.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>

        <p className="text-center text-base md:text-lg font-medium text-gray-800 mt-10 max-w-3xl mx-auto leading-relaxed">
          Наша задача — не просто провести обучение, а помочь сотрудникам применять новые навыки в реальной работе.
        </p>
      </div>
    </section>
  );
}